<template>
  <div>
    <div class="main">
      <h2>
        社員用アカウント
        <i class="el-icon-plus fr" @click="addAccount"></i>
      </h2>
      <ul>
        <li v-for="(item,index) in accountList" :key="index">
          <strong>{{index+1}}</strong>
          <p>
            <span>アカウント名:</span>
            {{item.ddusername}}
          </p>
          <p>
            <span>氏名:</span>
            {{item.realname}}
          </p>
          <div class="bianji" @click="edit(item)">
            <i class="el-icon-edit"></i>
            <div>編集</div>
          </div>
        </li>
      </ul>
      <div class="amend" v-show="show">
        <h3>アカウント</h3>
        <ol>
          <li>
            <span>アカウント名:</span>
            <input type="text" v-model="childAccount.ddusername" />
          </li>
          <li>
            <span>氏名:</span>
            <input type="text" v-model="childAccount.realname" />
          </li>
          <li>
            <span>ローマ字:</span>
            <input type="text" v-model="childAccount.nameroma" />
          </li>
          <li>
            <span>メールアドレス:</span>
            <input type="text" v-model="childAccount.email" />
          </li>
          <li>
            <span>パスワード:</span>
            <input type="text" v-model="childAccount.pwd" />
          </li>
        </ol>
        <h4>権限設定</h4>
        <dl>
          <dt>オーダー管理</dt>
          <dd>
            <input
              type="radio"
              name="danxuan"
              id
              :checked="childAccount.p1 == 1 "
              @change="childAccount.p1 = 1"
            />
            すべて
          </dd>
          <dd style="margin-left:100px">
            <input
              type="radio"
              name="danxuan"
              id
              :checked="childAccount.p1 == 2 "
              @change="childAccount.p1 =2"
            /> 自分のみ
          </dd>
        </dl>
        <dl>
          <dt>支払い</dt>
          <dd>
            <input
              type="radio"
              name="danxuan2"
              id
              :checked="childAccount.p2 == 1 "
              @change="childAccount.p2 = 1"
            /> すべて
          </dd>
          <dd style="margin-left:100px">
            <input
              type="radio"
              name="danxuan2"
              id
              :checked="childAccount.p2 == 2 "
              @change="childAccount.p2 = 2"
            /> なし
          </dd>
        </dl>
        <div class="btn">
          <button style="background:#F3C622;color:#fff" @click="save">保存</button>
          <button @click="show = false">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  childAccountList,
  updateChildAccount,
  addChildAccount
} from "../../../api/API/sonAccount";
export default {
  data() {
    return {
      token: localStorage.getItem("token"),
      show: false,
      state: 1,
      childAccount: {},
      accountList: []
    };
  },
  created() {
    this.childAccountList();
  },
  methods: {
    // 获取子账号list'
    childAccountList() {
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "childAccountList",
        token: this.token
      };
      childAccountList(list).then(res => {
        if (res.code != 1) return;
        this.accountList = res.data;
        console.log(res);
      });
    },
    // 编辑 子账号
    edit(item) {
      this.show = true;
      this.childAccount = item;
      this.state = 1;
    },
    // 添加 子账号
    addAccount() {
      this.show = true;
      this.state = 2;
      this.childAccount = {
        ddusername: "",
        realname: "",
        nameroma: "",
        email: "",
        pwd: "",
        p1: "",
        p2: ""
      };
    },
    // 保存修改
    save() {
      // 编辑state=1
      if (this.state == 1) {
        updateChildAccount(this.token, this.childAccount).then(res => {
          if (res.code != 1) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.show = false;
          this.childAccountList();
        });
        // 添加 state == 2
      } else {
        this.childAccount.password = this.childAccount.pwd;
        addChildAccount(this.token, this.childAccount).then(res => {
          if (res.code != 1) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.show = false;
          this.childAccountList();
        });
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.main {
  font-size: 20px;
  width: 1208px;
  h2 {
    height: 40px;
    line-height: 40px;
    background: #eee;
    padding-left: 20px;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1PX solid #ccc;
    color: #F3C622;
    i {
      line-height: 40px;
      margin-right: 30px;
      font-weight: 700;
      font-size: 25px;
      cursor: pointer;
    }
  }
  ul {
    // display: flex;
    margin-top: 30px;
    overflow: hidden;
    li {
      position: relative;
      width: 300px;
      float: left;
      height: 120px;
      border: 1PX solid #ccc;
      margin-right: 50px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
      border-radius: 20px;
      padding: 20px;
      margin-bottom: 20px;
      strong {
        color: #F3C622;
      }
      p {
        line-height: 40px;
      }
      .bianji {
        position: absolute;
        color: #F3C622;
        cursor: pointer;
        i {
          font-size: 25px;
          margin-left: 8px;
        }
        top: 20px;
        right: 20px;
      }
    }
  }
  .amend {
    border: 1PX solid #ccc;
    padding: 20px 20px 50px 20px;
    margin: 30px 0;
    ol {
      margin-top: 20px;
      padding-bottom: 50px;
      border-bottom: 1PX dashed #ccc;
      li {
        height: 34px;
        line-height: 34px;
        margin-bottom: 15px;
        span {
          display: inline-block;
          width: 300px;
          text-align: right;
          margin-right: 10px;
        }
        input {
          width: 300px;
          height: 32px;
          border: 1PX solid #ccc;
          font-size: 18px;
          padding-left: 5px;
        }
      }
    }
    h4 {
      margin: 50px 0;
      color: #F3C622;
    }
    dl {
      overflow: hidden;
      margin-bottom: 100px;
      dt {
        float: left;
        width: 200px;
        margin: 0 70px 0 50px;
        text-align: right;
      }
      dd {
        float: left;
        input {
          width: 25px;
          height: 25px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
    .btn {
      margin-left: 350px;
      button {
        padding: 0 20px;
        height: 40px;
        background: transparent;
        font-size: 20px;
        margin-right: 30px;
        cursor: pointer;
        border-radius: 5px;
      }
    }
  }
}
</style>